var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgVisibilityOff = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12076_63757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9231 12.8652C10.7889 13.5843 9.44384 14.0008 8.0015 14.0008C4.40672 14.0008 1.41607 11.4143 0.789062 8.00079C1.08018 6.41587 1.88085 5.00925 3.01495 3.95703L0.930409 1.8725L1.87322 0.929688L15.0726 14.129L14.1298 15.0719L11.9231 12.8652ZM3.95837 4.90045C3.07246 5.70742 2.4265 6.77879 2.14982 8.00079C2.76145 10.7021 5.1777 12.6675 8.0015 12.6675C9.06777 12.6675 10.076 12.3872 10.9508 11.8929L9.59864 10.5407C9.13617 10.8321 8.5885 11.0008 8.0015 11.0008C6.34462 11.0008 5.00148 9.65759 5.00148 8.00079C5.00148 7.41372 5.17008 6.86605 5.46151 6.4036L3.95837 4.90045ZM8.61057 9.55265L6.44961 7.39172C6.3755 7.58039 6.33481 7.78579 6.33481 8.00079C6.33481 8.92125 7.08104 9.66745 8.0015 9.66745C8.21644 9.66745 8.4219 9.62672 8.61057 9.55265ZM13.8725 11.0623L12.9186 10.1085C13.3559 9.48519 13.6782 8.77305 13.8531 8.00079C13.2415 5.29944 10.8252 3.33409 8.0015 3.33409C7.43757 3.33409 6.8899 3.41247 6.36963 3.55944L5.31761 2.50742C6.14882 2.18038 7.05417 2.00076 8.0015 2.00076C11.5962 2.00076 14.5869 4.58727 15.2139 8.00079C15.0058 9.13385 14.5372 10.1759 13.8725 11.0623ZM7.81657 5.00637C7.8777 5.00265 7.93937 5.00076 8.0015 5.00076C9.6583 5.00076 11.0015 6.34391 11.0015 8.00079C11.0015 8.06285 10.9996 8.12452 10.9959 8.18565L7.81657 5.00637Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12076_63757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVisibilityOff, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/visibility_off.40bda25a.svg";
export { ForwardRef as ReactComponent };